import { FC } from 'react';
import { SurveySubmission } from 'containers/surveys';
import { SurveyResultsLayout } from 'pages/atoms';

const SurveyResultsPage: FC = () => {
  return (
    <SurveyResultsLayout>
      <SurveySubmission />
    </SurveyResultsLayout>
  );
};

export default SurveyResultsPage;
